<template>
  <div :class="$style.frameLogin">
    <div :class="$style.frameParent">
      <div :class="$style.logo1Wrapper">
        <img :class="$style.logo1Icon" alt="" src="@/assets/logoYellow.svg" />
      </div>
      <div :class="$style.register">{{ $t('message.register') }}</div>
      <div :class="$style.inputFieldNegParent">
        <div v-for="(field, index) in inputFieldsPersonal" :key="index">
          <div :class="$style.label">{{ $t(field.label) }}*</div>
          <InputField
            v-if="field.label === 'message.email'"
            v-model="field.value"
            :inputFieldType="InputFieldType.Email"
            :borderColor="'#7F7F7F'"
          />
          <InputField
            v-if="field.label === 'message.name'"
            v-model="field.value"
            :inputFieldType="InputFieldType.Text"
            :borderColor="'#7F7F7F'"
          />
        </div>
        <div v-for="(field, index) in inputFieldsCompany" :key="index">
          <div v-if="field.required" :class="$style.label">{{ $t(field.label) }}*</div>
          <div v-else :class="$style.label">{{ $t(field.label) }}</div>
          <InputField
            v-if="field.required"
            v-model="field.value"
            :inputFieldType="InputFieldType.Text"
            :borderColor="'#7F7F7F'"
          />
          <InputField v-else v-model="field.value" :borderColor="'#7F7F7F'" />
        </div>
      </div>
      <div :class="$style.buttonBigNegWrapper">
        <ButtonPrimaryBigNeg
          :button-title="$t('message.send')"
          @handle-click="register"
          :disabled="!allFieldsNotEmpty"
        />
      </div>
      <div :class="$style.forgotPassword">
        <div @click="handleLogin">{{ $t('message.orLogin') }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import ButtonPrimaryBigNeg from '@/components/buttons/buttonPrimaryBigNeg.vue'
import InputField from '../common/InputField.vue'
import { InputFieldType } from '../common/InputFieldType'
import { useToast } from 'vue-toastification'

export default defineComponent({
  name: 'RegisterViewFrame',
  components: {
    InputField,
    ButtonPrimaryBigNeg
  },
  setup() {
    const registerUrl = import.meta.env.VITE_REGISTER_URL
    const router = useRouter()
    const value = ref('')
    const inputFieldsPersonal = reactive([
      { label: 'message.name', value: '', required: true },
      { label: 'message.email', value: '', required: true }
    ])
    const inputFieldsCompany = reactive([
      { label: 'message.company_name', value: '', required: true },
      { label: 'message.address', value: '', required: false },
      { label: 'message.business_identifier', value: '', required: false }
    ])

    const allFieldsNotEmpty = computed(() => {
      const personalFields = inputFieldsPersonal.every((field) => field.value.trim() !== '')
      const companyFields = inputFieldsCompany.every((field) =>
        field.required ? field.value.trim() !== '' : true
      )

      return personalFields && companyFields
    })

    const handleLogin = () => {
      router.replace('/')
    }

    const register = () => {
      const toast = useToast()
      toast.warning('Registration functionality is not yet implemented')
    }

    return {
      handleLogin,
      InputFieldType,
      registerUrl,
      value,
      inputFieldsPersonal,
      inputFieldsCompany,
      allFieldsNotEmpty,
      register
    }
  }
})
</script>

<style module>
.logo1Icon {
  width: 127.9px;
  position: relative;
  height: 50px;
  overflow: hidden;
  flex-shrink: 0;
}

.logo1Wrapper {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
´ .label {
  width: 100%;
  position: relative;
  letter-spacing: -0.02em;
  line-height: 110%;
}

.inputFieldContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.inputFieldNegParent {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.buttonBigNegWrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 16px 0px 8px;
  text-align: center;
  font-size: 26px;
  color: #f6f300;
  font-family: 'Antarlida';
}

.register {
  position: relative;
  line-height: 150%;
  font-weight: 600;
}

.forgotPassword {
  position: relative;
  text-decoration: underline;
  line-height: 150%;
  font-weight: 600;
}

.forgotPasswordWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.frameParent {
  width: 100%;
  position: relative;
  background-color: #000;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 40px 32px 32px;
  box-sizing: border-box;
  gap: 24px;
  text-align: left;
  font-size: 16px;
  color: #fff;
  font-family: 'Antarlida';
}

.frameLogin {
  width: 100%;
  max-width: 380px;
  margin: 0 auto;
  /* width: 380px; */
  height: auto;
  display: flex;
  box-sizing: border-box;
}
</style>
